import React, { FunctionComponent } from "react";

import commonStyles from "../../CommonStyles/CommonGraphStyles.module.css";

import IntBarTable from "../IntBarTable/IntBarTable";

import DoughnutChartOrg from "../DoughnutChartOrg/DoughnutChartOrg";

type props = {
  analyticsData: any;
  usersList: any;
  checked: boolean;
  teamsData: any;
  history: any;
  filter: "MTD" | "YTD" | "PM" | "All" | "CUSTOM";
  source: boolean;
  taskFilter: any;
  leadFilter: any;
};

const NotIntReason: FunctionComponent<props> = ({
  analyticsData,
  usersList,
  checked,
  history,
  teamsData,
  filter,
  source,
  taskFilter,
  leadFilter,
}) => {
  return (
    <>
      <div id="notIntReason" className={commonStyles.graphContainer}>
        <DoughnutChartOrg
          analyticsData={analyticsData}
          type={"not_int_reason"}
          color={["#ff9933", "#4FCE5D"]}
          style={{ width: "100%", height: "350px" }}
          history={history}
          filter={filter}
        />
      </div>
      <div id="notIntReason" className={commonStyles.graphContainer}>
        <IntBarTable
          data={analyticsData}
          type={"not_int_reason"}
          heading={"Not Interseted Reason Summary"}
          usersList={usersList}
          checked={checked}
          teamsData={teamsData}
          style={{ width: "100%" }}
          filter={filter}
          history={history}
          source={source}
          taskFilter={taskFilter}
          leadFilter={leadFilter}
        />
      </div>
    </>
  );
};

export default NotIntReason;
